import { useIntl } from 'react-intl';
import { commonMessages } from 'messages';
import { EAuthRoutes } from '@agco-onedigital/ecosystem-lib-frontend-utils';
import { IListItem, ISidebarItem, ISidebarProps, TSidebarIcon } from './types';

const menuMessages = commonMessages.menu;

export const useDataAndPrivacySidbarItem = (isDataAndPrivacyEnabled: boolean) => {
  const { formatMessage } = useIntl();
  const items = [
    {
      key: 'marketing-preferences',
      label: formatMessage(commonMessages.registration.consentFinish.marketing),
      to: `${EAuthRoutes.USER}${EAuthRoutes.MARKETING_PREFERENCES}`,
      testId: 'sidebar-marketing-preferences',
    },
  ];

  return isDataAndPrivacyEnabled ? items : [];
};

export const useCommonUserMenuItems = () => {
  const { formatMessage } = useIntl();
  return [
    {
      key: 'log-in-and-security',
      label: formatMessage(menuMessages.logInAndSecurity),
      to: `${EAuthRoutes.USER}${EAuthRoutes.LOGIN_AND_SECURITY}`,
      testId: 'sidebar-log-in-and-security',
    },
    {
      key: 'personal-data',
      label: formatMessage(menuMessages.personalData),
      to: `${EAuthRoutes.USER}${EAuthRoutes.PERSONAL_DATA}`,
      testId: 'sidebar-personal-data',
    },
  ];
};

export const useSmartFarmingItems = (externalLinks: ISidebarProps['externalLinks']): ISidebarItem[] => {
  const { formatMessage } = useIntl();

  if (!externalLinks) {
    return [];
  }

  const { appNameFendt, appNameValtra, appNameMassey } = commonMessages.smartFarming;
  const items: IListItem[] = [
    {
      label: formatMessage(appNameFendt),
      key: 'fendt',
      to: externalLinks?.fendt || '',
      trailingIcon: 'launch' as TSidebarIcon,
      isTargetBlank: true,
    },
    {
      label: formatMessage(appNameValtra),
      key: 'valtra',
      to: externalLinks?.valtra || '',
      trailingIcon: 'launch' as TSidebarIcon,
      isTargetBlank: true,
    },
    {
      label: formatMessage(appNameMassey),
      key: 'massey-ferguson',
      to: externalLinks?.massey || '',
      trailingIcon: 'launch' as TSidebarIcon,
      isTargetBlank: true,
    },
  ].filter(i => i.to !== '');

  return [
    {
      label: formatMessage(menuMessages.smartFarming),
      icon: 'agco_machines-outline',
      type: 'list',
      testId: 'test-id-smart-farming',
      listData: {
        basePath: EAuthRoutes.SMART_FARMING,
        items,
      },
    },
  ];
};
